import { Injectable } from '@angular/core';
import { applyTransaction } from '@datorama/akita';
import { NGXLogger } from 'ngx-logger';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import offerData from '../../data/offer.data';
import { ApiService } from '../api/api.service';
import { OfferStore } from './offer.store';
import { RedeemedOffer } from './offer.type';
@Injectable({
  providedIn: 'root',
})
export class OfferService {
  constructor(
    private offerStore: OfferStore,
    private api: ApiService,
    private logger: NGXLogger,
  ) {}

  /**
   * Get list of offers from backend
   */
  getOffers(forceRefresh = true) {
    this.offerStore.setLoading(true);
    return this.api.getOffersV2(forceRefresh).pipe(
      map((response) => {
        if (response.success) {
          this.offerStore.update({ ...response, loaded: true });
          return response.data;
        } else {
          return [];
        }
      }),
      tap(() => this.offerStore.setLoading(false)),
      catchError((err) => {
        applyTransaction(() => {
          this.offerStore.setError(err);
          this.offerStore.setLoading(false);
        });
        throw err;
      }),
      // finalize(() => {
      // Sometimes, finalize change is not detected
      //   this.offerStore.setLoading(false)
      // }),
    );
  }

  /**
   * Get offers to be displayed on dummy home page
   */
  getDummyOffers() {
    this.offerStore.setLoading(true);
    return this.api.getDummyOffers().pipe(
      // tap((response) => {
      //   this.offerStore.update({ dummyOffers: response });
      // }),
      catchError((error) => {
        this.logger.error('getDummyOffers() error:', error);
        applyTransaction(() => {
          this.offerStore.setError(error);
          this.offerStore.setLoading(false);
        });
        throw error;
      }),
    );
  }

  redeemOffer(offerId: number) {
    this.offerStore.setLoading(true);
    return this.api.redeemOffer(offerId).pipe(
      catchError((err) => {
        this.offerStore.setError(err);
        throw err;
      }),
      finalize(() => this.offerStore.setLoading(false)),
    );
  }

  getRedeemedOffers(redeemedId?: number) {
    this.offerStore.setLoading(true);
    return this.api.getRedeemedOffers(redeemedId).pipe(
      tap((result) => {
        if (!redeemedId) this.offerStore.update({ redeemedOffers: result as RedeemedOffer[] });
        else
          this.offerStore.update({
            currRedeemId: redeemedId,
            redeemedOffer: result as RedeemedOffer,
          });
      }),
      catchError((err) => {
        this.offerStore.setError(err);
        throw err;
      }),
      finalize(() => this.offerStore.setLoading(false)),
    );
  }

  getOffer(id: number) {
    return offerData.find((x) => x.id === id);
  }

  getPromoCodesAvailable() {
    return this.api.getAvailablePromoCodes();
  }

  redeemPromoCode(amount: number) {
    return this.api.redeemPromoCode(amount);
  }

  getRedeemedPromoCodes() {
    return this.api.getRedeemedPromoCodes().pipe(
      tap((promoCodes) => {
        this.offerStore.update({ redeemedPromoCodes: promoCodes });
      }),
      catchError((error) => {
        this.offerStore.setError(error);
        throw error;
      }),
    );
  }
}
